/** A tracked sheet row's stored status: whether it could be read into tags and assets. */
export enum AssetSheetRowStatus {
	/** Every cell matched; its assets are downloaded and tagged. */
	MAPPED = 'MAPPED',
	/** At least one cell could not be read; `problems` says which. Its tags are left as they are. */
	BLOCKED = 'BLOCKED',
	/** No longer in the sheet; its tags are removed. */
	REMOVED = 'REMOVED',
}

/** A row's status as the admin rows endpoint derives it from the row and its assets' imports. */
export enum AssetSheetDerivedRowStatus {
	DONE = 'DONE',
	IN_PROGRESS = 'IN_PROGRESS',
	HAS_FAILURES = 'HAS_FAILURES',
	BLOCKED = 'BLOCKED',
	REMOVED = 'REMOVED',
}

/** What a column's cell references. */
export enum AssetSheetObjectType {
	/** Vault document numbers, each imported as library files. */
	FILE = 'file',
}

/** Which of the row's brand and product an asset column's files are tagged with. */
export enum AssetSheetLevel {
	/** The brand only. */
	BRAND = 'brand',
	/** The product. */
	PRODUCT = 'product',
	/** Neither: only the file type and the country. */
	MARKET = 'market',
}
